import request from "../utils/request";

export async function getProductSizeList() {
  return request.get("ProductSize/List");
}

export async function deleteProductSize(id){
  return request.delete("ProductSize/Delete?id=" + id);
}

export async function createProductSize(payload){
  return request.post("ProductSize/Create",payload);
}

export async function updateProductSize(payload){
  return request.post("ProductSize/Update",payload)
}
